export const CATEGORY_PARAM_NAME = 'categoryUid';
